import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import { Link, useHistory, useParams, NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  useAppUserDetailsSelector,
  useAppUserTokenSelector,
  useAppUserPermissionsSelector,
  useAppUserDataSelector,
} from "src/_common/hooks/selectors/userSelector";
import { URLS, detectDevice, RODEO_PAGE_NAME, handleApiCall, ACTIONS } from "src/_config";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import SiteLogo from "./SiteLogo";
import SettingsSidebar from "./SettingsSidebar";
import { useEmployerJobApi } from "src/_common/hooks/actions/job/appEmployerJobApiHook";
import { useTranslation } from "src/_common/hooks/useTranslation";
import UpgradePlanModal from "../modal/UpgradePlanModal";
import NotificationPanel from "../modal/NotificationPanel";
import ExperienceRatingModal from "../modal/ExperienceRatingModal";
import { hasPermission } from "src/_common/utils/permissionsUtils";
import { useJobListSelector } from "src/_common/hooks/selectors/jobSelector.";

function Sidebar({ page, showSettingsSidebar: propShowSettingsSidebar }: any) {
  const { t } = useTranslation("sidebar");
  const dispatch = useDispatch();
  const userApi = useUserApi();
  const history = useHistory();
  const userDetails = useAppUserDetailsSelector();
  const userPermissions = useAppUserPermissionsSelector();
  const userData = useAppUserDataSelector();
  const { callGetEmployerJobs } = useEmployerJobApi();

  const { rodeoEventId, performanceId, eventId } = useParams<any>();
  const userAction = useAppUserAction();
  const eventAction = useAppEventAction();

  // Helper function to check if email is verified
  const isEmailVerified = (): boolean => {
    return userDetails?.user?.is_verified === true;
  };

  // Helper function to check permissions for member users
  const canAccessMenu = (menuName: string): boolean => {
    // For members, strictly check permissions - only show if they have access
    if (userDetails?.user_type === "member") {
      return hasPermission(userPermissions, menuName);
    }

    // Non-members (employers/admins) have access to all menus
    return true;
  };

  // const [isShowIosPopup, setIsShowIosPopup] = useState<any>(
  //   localStorage.getItem(IS_SHOWING_ADD_TO_HOME_SCREEN_IOS)
  //     ? parseInt(localStorage.getItem(IS_SHOWING_ADD_TO_HOME_SCREEN_IOS) || "0")
  //     : 1
  // );
  const [showCreatorPopup, setShowCreatorPopup] = useState<boolean>(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState<boolean>(false);
  const [showNotificationPanel, setShowNotificationPanel] = useState<boolean>(false);
  const [showExperienceRatingModal, setShowExperienceRatingModal] = useState<boolean>(false);
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
  const [showMyJobsDropdown, setShowMyJobsDropdown] = useState<boolean>(false);
  const [employerJobs, setEmployerJobs] = useState<any[]>([]);
  const [isLoadingJobs, setIsLoadingJobs] = useState<boolean>(true);
  // const employerJobs = useJobListSelector();
  const [showSettingsSidebar, setShowSettingsSidebar] = useState<boolean>(propShowSettingsSidebar || false);
  const creatorPopupRef = useRef<HTMLDivElement>(null);

  // const [cookiesPopup, setCookiesPopup] = useState<boolean>(true);
  const userToken = useAppUserTokenSelector();

  const toogleSideBarOnOff = (status: boolean) => {
    var sidebarCollapseElement = document.getElementById("sidebarCollapse");
    var sidebarElement = document.getElementById("sidebar");
    var overlayElement = document.getElementById("overlay");
    if (status) {
      if (sidebarCollapseElement) {
        sidebarElement?.classList.add("active");
        overlayElement?.classList.add("active");
      }
    } else {
      if (sidebarCollapseElement) {
        sidebarElement?.classList.remove("active");
        overlayElement?.classList.remove("active");
      }
    }
  };

  const toggleSidebarCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleSettingsClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // If email is not verified, prevent access to settings
    if (!isEmailVerified()) {
      return;
    }
    setShowSettingsSidebar(true);
    setShowCreatorPopup(false);
    // Navigate to members page by default when opening settings
    history.push(URLS.MEMBERS.LIST);
  };

  const handleBackToDashboard = () => {
    setShowSettingsSidebar(false);
    history.push(URLS.DASHBOARD.MAIN);
  };

  const logOut = (e: React.MouseEvent) => {
    e.preventDefault();
    userApi.callLogout(
      (message: string, resp: any) => {
        // API logout successful
        toogleSideBarOnOff(false);
        history.push(URLS.AUTH.LOGIN);
      },
      (message: string) => {
        // API logout failed, still clear local state
        userAction.logout();
        toogleSideBarOnOff(false);
        history.push(URLS.AUTH.LOGIN);
      },
    );
    // localStorage.removeItem(STORAGE);
    // localStorage.removeItem(SELECTED_EVENT_STORAGE);
  };

  const deleteCookiesPopup = () => {
    $(".top_fixedsec").hide();
    localStorage.setItem("is_cookie_screen_popup", "0");
  };

  const deletePopup = () => {
    $(".bottom_fixedsec").hide();
    localStorage.setItem("is_add_screen_popup", "0");
  };

  const fetchEmployerJobs = (employerId: any) => {
    const params = {
      job_status: ["ai_filter", "open", "rejected"],
      // limit: 10,
      // offset: 0,
      not_required_count: true,
    };
    console.log("Fetching employer jobs for employerId:", employerId);
    setIsLoadingJobs(true);

    callGetEmployerJobs(
      // "648579",
      employerId,
      params,
      (message: string, data: any) => {
        console.log("Success:", data);
        setEmployerJobs(data.jobs || []);
        setIsLoadingJobs(false);
      },
      (errorMessage: string, errorData: any) => {
        console.error("Error:", errorMessage);
        setIsLoadingJobs(false);
      },
    );
  };

  const handleCompanyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // If email is not verified, prevent access to company profile
    if (!isEmailVerified()) {
      return;
    }
    // For members, navigate to view profile with company view
    console.log(canAccessMenu("edit_company"));
    if (userDetails?.user_type === "member" && canAccessMenu("edit_company")) {
      setShowCreatorPopup(false);
      toogleSideBarOnOff(false);
      history.push(`${URLS.AUTH.VIEW_PROFILE}?view=company`);
    } else if (userDetails?.user_type !== "member") {
      // For non-members, also navigate to company view
      setShowCreatorPopup(false);
      toogleSideBarOnOff(false);
      history.push(`${URLS.AUTH.VIEW_PROFILE}?view=company`);
    }
    // else if (canAccessMenu("read_company")) {
    //   console.log("Navigating to company profile");
    // }
  };

  useEffect(() => {
    console.log("User Details changed:", userDetails);
    // if (userDetails && userDetails.user && userDetails.user.id) {
    //   fetchEmployerJobs(userDetails.user.id);
    // }
    if (userDetails && userDetails.user && userDetails.user.company_id) {
      fetchEmployerJobs(userDetails.user.company_id);
    }
  }, [userDetails]);

  // Update settings sidebar based on prop or specific pages
  useEffect(() => {
    if (propShowSettingsSidebar !== undefined) {
      setShowSettingsSidebar(propShowSettingsSidebar);
    } else if (page === RODEO_PAGE_NAME.MEMBERS) {
      setShowSettingsSidebar(true);
    } else {
      setShowSettingsSidebar(false);
    }
  }, [page, propShowSettingsSidebar]);

  // Fetch user data and store in Redux
  useEffect(() => {
    userApi.callGetUserData(
      (message: string, response: any) => {
        dispatch({
          type: ACTIONS.USER.SET_USER_DATA,
          payload: response,
        });
      },
      (errorMessage: string) => {
        console.error("Failed to fetch user data:", errorMessage);
      },
    );
  }, []);

  // Handle click outside creator popup to close it
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (creatorPopupRef.current && !creatorPopupRef.current.contains(event.target as Node)) {
        setShowCreatorPopup(false);
      }
    };

    if (showCreatorPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCreatorPopup]);

  return (
    <>
      <div className="overlay" id="overlay" onClick={() => toogleSideBarOnOff(false)} />
      {showSettingsSidebar ? (
        <SettingsSidebar isCollapsed={isCollapsed} onBackToDashboard={handleBackToDashboard} />
      ) : (
        <section className={`${isCollapsed ? "top-nav sidebar-wrap-collapse" : "top-nav "}`}>
          <nav
            id="sidebar"
            className={`mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar ${
              isCollapsed ? "sidebar-collapsed" : ""
            }`}
            style={{ overflow: "visible" }}
          >
            <div id="dismiss" onClick={toggleSidebarCollapse}>
              <i className={`fa ${isCollapsed ? "fa-arrow-right" : "fa-arrow-left"}`} />
            </div>
            {!isCollapsed ? (
              <div className="sidebar-header">
                <SiteLogo />
              </div>
            ) : (
              <div className="sidebar-header">
                <SiteLogo isCollapsed={isCollapsed} />
              </div>
            )}
            <ul
              className={`list-unstyled components ${isCollapsed ? "icons-only" : ""}`}
              onClick={() => toogleSideBarOnOff(false)}
            >
              {/* Dashboard Navigation - Always visible for members, permission-based for others */}
              {(userDetails?.user_type === "member" || canAccessMenu("dashboard")) && (
                <li className={!isEmailVerified() ? "disabled" : ""}>
                  <NavLink
                    exact
                    to={URLS.DASHBOARD.MAIN}
                    activeClassName="active"
                    onClick={(e) => {
                      if (!isEmailVerified()) {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      opacity: !isEmailVerified() ? 0.5 : 1,
                      cursor: !isEmailVerified() ? "not-allowed" : "pointer",
                      pointerEvents: !isEmailVerified() ? "none" : "auto",
                    }}
                  >
                    <i className="sidebar-icon dashboard-nav-icon"></i>
                    <span className="nav-text">{t("sidebar.navigation.dashboard")}</span>
                  </NavLink>
                </li>
              )}
              {canAccessMenu("create_my_jobs") && (
                <li className={!isEmailVerified() ? "disabled" : ""}>
                  <NavLink
                    to={URLS.JOB_POSTING.NEW}
                    activeClassName="active"
                    onClick={(e) => {
                      if (!isEmailVerified()) {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      opacity: !isEmailVerified() ? 0.5 : 1,
                      cursor: !isEmailVerified() ? "not-allowed" : "pointer",
                      pointerEvents: !isEmailVerified() ? "none" : "auto",
                    }}
                  >
                    <i className="sidebar-icon new-job-posting-nav-icon"></i>
                    <span className="nav-text">{t("sidebar.navigation.newJobPosting")}</span>
                  </NavLink>
                </li>
              )}
              {canAccessMenu("create_filter") && (
                <li className={!isEmailVerified() ? "disabled" : ""}>
                  <NavLink
                    to={URLS.JOB_POSTING.AI_CANDIDATE_SEARCH}
                    activeClassName="active"
                    onClick={(e) => {
                      if (!isEmailVerified()) {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      opacity: !isEmailVerified() ? 0.5 : 1,
                      cursor: !isEmailVerified() ? "not-allowed" : "pointer",
                      pointerEvents: !isEmailVerified() ? "none" : "auto",
                    }}
                  >
                    <i className="sidebar-icon ai-candidate-search-nav-icon"></i>
                    <span className="nav-text">{t("sidebar.navigation.aiCandidateSearch")}</span>
                  </NavLink>
                </li>
              )}
              {canAccessMenu("read_my_jobs") && (
                <li
                  className={`dropdown-menu-item ${showMyJobsDropdown ? "active" : ""} ${!isEmailVerified() ? "disabled" : ""}`}
                >
                  <div
                    className="nav-item-with-dropdown"
                    onClick={() => {
                      if (isEmailVerified()) {
                        setShowMyJobsDropdown(!showMyJobsDropdown);
                      }
                    }}
                    style={{
                      opacity: !isEmailVerified() ? 0.5 : 1,
                      cursor: !isEmailVerified() ? "not-allowed" : "pointer",
                    }}
                  >
                    <NavLink to="/my-jobs" activeClassName="active" onClick={(e) => e.preventDefault()}>
                      <i className="sidebar-icon my-jobs-nav-icon"></i>
                      <span className="nav-text">{t("sidebar.navigation.myJobs")}</span>
                      <i
                        className={`dropdown-arrow fa ${showMyJobsDropdown ? "fa-chevron-up" : "fa-chevron-down"}`}
                      ></i>
                    </NavLink>
                  </div>
                  {showMyJobsDropdown && (
                    <ul className="dropdown-submenu">
                      {isLoadingJobs ? (
                        <li>
                          <span style={{ display: "flex", alignItems: "center", gap: "8px", padding: "8px 0" }}>
                            <i className="fa fa-spinner fa-spin"></i>
                            {t("sidebar.myJobsDropdown.loading")}
                          </span>
                        </li>
                      ) : (
                        <>
                          {employerJobs
                            .filter((job) => job.status === 1 || job.status === 10)
                            .slice(0, 5)
                            .map((job, index) => (
                              <li key={job.emp_job_id || index}>
                                <Link to={`/job-details/${job.emp_job_id}`}>
                                  {job.job_title}{" "}
                                  <span
                                    className={`job-status ${
                                      job.status == 1 ? "status-live" : job.status == 10 ? "status-filter" : ""
                                    }`}
                                  >
                                    {job.status == 1
                                      ? t("sidebar.myJobsDropdown.statusLive")
                                      : job.status == 10
                                        ? t("sidebar.myJobsDropdown.statusFilter")
                                        : ""}
                                  </span>
                                </Link>
                              </li>
                            ))}
                          {employerJobs.filter((job) => job.status === 1 || job.status === 10).length > 5 && (
                            <li className="view-more-item">
                              <Link to={URLS.JOB_POSTING.JOB_LISTINGS} className="view-more-link">
                                {t("sidebar.myJobsDropdown.viewMore")}
                              </Link>
                            </li>
                          )}
                          {employerJobs.length === 0 && (
                            <li>
                              <span>{t("sidebar.myJobsDropdown.noJobsFound")}</span>
                            </li>
                          )}
                        </>
                      )}
                    </ul>
                  )}
                </li>
              )}
              {/* Candidate Search - Hidden for now
              {canAccessMenu("read_candidates") && (
                <li className={!isEmailVerified() ? "disabled" : ""}>
                  <NavLink
                    to={URLS.CANDIDATES.MAIN}
                    activeClassName="active"
                    onClick={(e) => {
                      if (!isEmailVerified()) {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      opacity: !isEmailVerified() ? 0.5 : 1,
                      cursor: !isEmailVerified() ? "not-allowed" : "pointer",
                      pointerEvents: !isEmailVerified() ? "none" : "auto",
                    }}
                  >
                    <i className="sidebar-icon cadidate-nav-icon"></i>
                    <span className="nav-text">{t("sidebar.navigation.candidates")}</span>
                  </NavLink>
                </li>
              )}
              */}
              {canAccessMenu("read_candidates") && (
                <li className={!isEmailVerified() ? "disabled" : ""}>
                  <NavLink
                    to={URLS.CANDIDATE_ADVANCED_SEARCH.MAIN}
                    activeClassName="active"
                    onClick={(e) => {
                      if (!isEmailVerified()) {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      opacity: !isEmailVerified() ? 0.5 : 1,
                      cursor: !isEmailVerified() ? "not-allowed" : "pointer",
                      pointerEvents: !isEmailVerified() ? "none" : "auto",
                    }}
                  >
                    <i className="sidebar-icon cadidate-nav-icon"></i>
                    <span className="nav-text">Candidate Search</span>
                  </NavLink>
                </li>
              )}
              {/* Video CV - Hidden for now
              {canAccessMenu("read_video_cv") && (
                <li className={!isEmailVerified() ? "disabled" : ""}>
                  <NavLink
                    to={URLS.VIDEO_CV.MAIN}
                    activeClassName="active"
                    onClick={(e) => {
                      if (!isEmailVerified()) {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      opacity: !isEmailVerified() ? 0.5 : 1,
                      cursor: !isEmailVerified() ? "not-allowed" : "pointer",
                      pointerEvents: !isEmailVerified() ? "none" : "auto",
                    }}
                  >
                    <i className="sidebar-icon video-cv-nav-icon"></i>
                    <span className="nav-text">{t("sidebar.navigation.videoCv")}</span>
                  </NavLink>
                </li>
              )}
              */}
              {canAccessMenu("read_interview_schedule") && (
                <li className={!isEmailVerified() ? "disabled" : ""}>
                  <NavLink
                    to={URLS.INTERVIEW.AVALIBILITY}
                    activeClassName="active"
                    onClick={(e) => {
                      if (!isEmailVerified()) {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      opacity: !isEmailVerified() ? 0.5 : 1,
                      cursor: !isEmailVerified() ? "not-allowed" : "pointer",
                      pointerEvents: !isEmailVerified() ? "none" : "auto",
                    }}
                  >
                    <i className="sidebar-icon interview-schedule-nav-icon"></i>
                    <span className="nav-text">{t("sidebar.navigation.interviewSchedule")}</span>
                  </NavLink>
                </li>
              )}
              {canAccessMenu("read_reports") && (
                <li className={!isEmailVerified() ? "disabled" : ""}>
                  <NavLink
                    to={URLS.REPORTS.MAIN}
                    activeClassName="active"
                    onClick={(e) => {
                      if (!isEmailVerified()) {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      opacity: !isEmailVerified() ? 0.5 : 1,
                      cursor: !isEmailVerified() ? "not-allowed" : "pointer",
                      pointerEvents: !isEmailVerified() ? "none" : "auto",
                    }}
                  >
                    <i className="sidebar-icon reports-nav-icon"></i>
                    <span className="nav-text">{t("sidebar.navigation.reports")}</span>
                  </NavLink>
                </li>
              )}
              {/* {userDetails ? (
            <li>
              <Link to="#" onClick={(e) => logOut(e)}>
                Logout
              </Link>
            </li>
          ) : null} */}
            </ul>
            {/* Pinned items above creator badge */}
            <div className="sidebar-pinned-bottom">
              {canAccessMenu("read_subscriptions") && (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowUpgradeModal(true);
                  }}
                  data-tooltip="Plans & Pricing"
                >
                  <i className="sidebar-icon upgrade-plan-nav-icon"></i>
                  <span className="nav-text">{t("sidebar.creatorBadge.upgradePlan")}</span>
                </a>
              )}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setShowNotificationPanel(true);
                }}
                className={showNotificationPanel ? "active" : ""}
              >
                <i className="sidebar-icon notification-nav-icon"></i>
                <span className="nav-text">{t("sidebar.navigation.notification")}</span>
                {userData?.notifications?.unread_count > 0 && (
                  <span className="notification-badge">{userData?.notifications?.unread_count}</span>
                )}
              </a>
            </div>
            {/* Creator Badge for Dashboard */}
            <div className="drjob-creator-badge">
              <div className="creator-trigger" onClick={() => setShowCreatorPopup(!showCreatorPopup)}>
                <img
                  src={(userDetails?.company as any)?.logo_url || "/images/company-avatar.jpg"}
                  alt="Dr Job FZ LLC"
                />
                <div className="creator-info">
                  <span className="creator-name">{(userDetails?.company as any)?.name}</span>
                  <span className="creator-count">
                    <i className="creator-icon"></i> 1 {t("sidebar.creatorBadge.creator")}
                  </span>
                </div>
                <span className="creator-arrow">{showCreatorPopup ? "▲" : "▼"}</span>
              </div>

              {/* Creator Popup */}
              {showCreatorPopup && (
                <div className="creator-popup" ref={creatorPopupRef}>
                  {/* Company Info - Only show for members */}

                  <div
                    className="popup-section"
                    onClick={handleCompanyClick}
                    style={{
                      cursor:
                        !isEmailVerified() || (userDetails?.user_type === "member" && !canAccessMenu("edit_company"))
                          ? "not-allowed"
                          : "pointer",
                      opacity: !isEmailVerified() ? 0.5 : 1,
                    }}
                  >
                    <h4>{t("sidebar.creatorBadge.companyInfo")}</h4>
                    {isEmailVerified() &&
                    (userDetails?.user_type !== "member" ||
                      (userDetails?.user_type === "member" && canAccessMenu("edit_company"))) ? (
                      <Link
                        to={`${URLS.AUTH.VIEW_PROFILE}?view=company`}
                        className="user-profile"
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowCreatorPopup(false);
                          toogleSideBarOnOff(false);
                        }}
                      >
                        {/* <div className="company-profile"> */}
                        <img
                          src={(userDetails?.company as any)?.logo_url || "/images/company-avatar.jpg"}
                          alt="Dr Job FZ LLC"
                        />
                        <div className="company-details">
                          <h6>{userDetails?.company?.name}</h6>
                          {/* <p>{userDetails?.user_type != "member" && (userDetails?.user as any)?.email}</p> */}
                        </div>
                        {/* </div> */}
                      </Link>
                    ) : (
                      <div className="user-profile">
                        {/* <div className="company-profile"> */}
                        <img
                          src={(userDetails?.company as any)?.logo_url || "/images/company-avatar.jpg"}
                          alt="Dr Job FZ LLC"
                        />
                        <div className="company-details">
                          <h6>{userDetails?.company?.name}</h6>
                          {/* <p>{userDetails?.user_type != "member" && (userDetails?.user as any)?.email}</p> */}
                        </div>
                        {/* </div> */}
                      </div>
                    )}
                  </div>

                  {/* Personal Info */}
                  <div className="popup-section">
                    <h4>{t("sidebar.creatorBadge.personalInfo")}</h4>
                    <Link
                      to={
                        userDetails?.user_type !== "member"
                          ? `${URLS.AUTH.VIEW_PROFILE}?view=personal`
                          : URLS.AUTH.VIEW_PROFILE
                      }
                      className="user-profile"
                      onClick={() => {
                        setShowCreatorPopup(false);
                        toogleSideBarOnOff(false);
                      }}
                    >
                      <img
                        src={
                          (userDetails?.user_type == "member"
                            ? userDetails?.user?.profile_photo_url
                            : (userDetails as any)?.user?.profile_image_url) || "/images/user-avatar.jpg"
                        }
                      />
                      <div className="user-details">
                        <h5>{userDetails?.user_type === "member" ? userDetails?.user?.name : "My Profile"}</h5>
                        <p>{userDetails?.user?.email}</p>
                      </div>
                    </Link>
                  </div>

                  {/* Menu Options */}
                  <div className="popup-menu">
                    {/* Show for non-members OR for members (Upgrade Plan, Settings, Support) */}
                    {/* {userDetails?.user_type !== "member" ? ( */}

                    <a
                      href="#"
                      className={`popup-menu-item upgrade ${!canAccessMenu("read_subscriptions") ? "d-none" : ""}`}
                      onClick={(e) => {
                        e.preventDefault();
                        setShowUpgradeModal(true);
                      }}
                      // Allow upgrade even if not verified
                      style={{}}
                    >
                      <span className="upgrade-icon"></span>
                      <span>{t("sidebar.creatorBadge.upgradePlan")}</span>
                    </a>
                    <a
                      href="#"
                      className={`popup-menu-item ${!isEmailVerified() ? "disabled" : ""}`}
                      onClick={handleSettingsClick}
                      style={{
                        opacity: !isEmailVerified() ? 0.5 : 1,
                        cursor: !isEmailVerified() ? "not-allowed" : "pointer",
                        pointerEvents: !isEmailVerified() ? "none" : "auto",
                      }}
                    >
                      <span className="settings-icon"></span>
                      <span>{t("sidebar.creatorBadge.settings")}</span>
                    </a>
                    <a
                      href="#"
                      className="popup-menu-item"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowExperienceRatingModal(true);
                      }}
                    >
                      <span className="share-feedback-icon"></span>
                      <span>{t("sidebar.creatorBadge.shareFeedback")}</span>
                    </a>
                    {/* {URLS.SUPPORT.CONTACT_US} */}
                    <a
                      href="https://support.drjobpro.com/hc/en-us"
                      className="popup-menu-item"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="support-icon"></span>
                      <span>{t("sidebar.creatorBadge.support")}</span>
                    </a>

                    {/* ) : ( */}
                    {/* For members: Show Upgrade Plan, Settings, Support below Company Info   */}
                    {/* <>
                      <a href="#" className="popup-menu-item upgrade" onClick={(e) => { e.preventDefault(); setShowUpgradeModal(true); }}>
                        <span className="upgrade-icon"></span>
                        <span>{t("sidebar.creatorBadge.upgradePlan")}</span>
                      </a>
                      <a href="#" className="popup-menu-item" onClick={handleSettingsClick}>
                        <span className="settings-icon"></span>
                        <span>{t("sidebar.creatorBadge.settings")}</span>
                      </a>
                      <a href="#" className="popup-menu-item">
                        <span className="support-icon"></span>
                        <span>{t("sidebar.creatorBadge.support")}</span>
                      </a>
                    </> */}
                    {/* )} */}
                    <a
                      href="#"
                      className="popup-menu-item logout"
                      onClick={(e) => {
                        e.preventDefault();
                        logOut(e);
                      }}
                    >
                      <span className="log-out-icon"></span>
                      <span>{t("sidebar.creatorBadge.logOut")}</span>
                    </a>
                  </div>
                </div>
              )}
            </div>
            {/* )} */}
          </nav>
        </section>
      )}

      {/* Upgrade Plan Modal */}
      <UpgradePlanModal isVisible={showUpgradeModal} onClose={() => setShowUpgradeModal(false)} />

      {/* Notification Panel */}
      <NotificationPanel isOpen={showNotificationPanel} onClose={() => setShowNotificationPanel(false)} />

      {/* Experience Rating Modal */}
      <ExperienceRatingModal isOpen={showExperienceRatingModal} onClose={() => setShowExperienceRatingModal(false)} />

      {localStorage.getItem("is_cookie_screen_popup") != "0" ? (
        <div className="top_fixedsec">
          <p>{t("sidebar.popups.cookies.message")}</p>
          <a href="javascript:void(0)">
            <button className="rkmd-btn btn-lg btn-orange ripple-effect w-50" onClick={(e) => deleteCookiesPopup()}>
              {t("sidebar.popups.cookies.accept")}
            </button>
          </a>
        </div>
      ) : null}
    </>
  );
}

export default Sidebar;
